let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6fU2k")).then(() => parcelRequire('iPviL'));